import { initAccordions } from "../../../src/js/modules/accordion";
import { initOnScrollAnimation } from "../../../src/js/modules/on-scroll-animations";
import { initTabs } from "../../../src/js/modules/tabs";

document.querySelectorAll(".js-expertise").forEach((el) => {
	initAccordions(el);
	initTabs(el);
	initOnScrollAnimation(el);
});
